import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCollectionMethodChartsDataContext } from './hooks/useCollectionMethodChartsDataContext';

export const FamiliesPerEstablishmentSocialAssistance = () => {
    const { chartData } = useCollectionMethodChartsDataContext();

    return (
        <SimpleBars
            title={
                'Total de Famílias por Estabelecimento de Assistência Social'
            }
            horizontal={true}
            subtitles={chartData?.familiesPerEstablishmentSocialAssistance?.map(
                (item) => item.description
            )}
            values={chartData?.familiesPerEstablishmentSocialAssistance?.map(
                (item) => item.total || 0
            )}
        />
    );
};
